export default "__VITE_ASSET__Bbyfturf__"